import React from 'react'

import Reason from "./Reason"
import { reasons } from "../data"

export default function Reasons() {
  const { title, description } = reasons

  return (
    <div className="reasons">
      <h2 className="title txs">Que pouvez vous tirer de cette formation ?</h2>
      <div className="reason_container">
        {reasons.map(reason => (
          <Reason reason={reason} key={Math.random()}/>
        ))}
      </div>
    </div>
  )
}
